import React, { Component, Fragment} from 'react'
import { withRouter } from 'react-router'

import SingleSegment from 'containers/SingleSegment'

class SingleSegmentMembers extends Component {
  render() {
    return (
      <Fragment>
        <SingleSegment {...this.props} />
      </Fragment>
    )
  }
}

export default withRouter(SingleSegmentMembers)